import type { PlanTier } from '@/lib/billing'

export type ComparisonValue = boolean | string

export type ComparisonFeature = {
  id: string
  label: string
  helper?: string
  // If true, this feature is highlighted in the "preview" or "key differences" section
  important?: boolean
  values: Record<PlanTier, ComparisonValue>
}

export type ComparisonCategory = {
  id: string
  label: string
  features: ComparisonFeature[]
}

export const PRICING_COMPARISON_DATA: ComparisonCategory[] = [
  {
    id: 'core-features',
    label: 'Características Principales',
    features: [
      {
        id: 'messages',
        label: 'Mensajes Incluidos',
        helper: 'Cantidad de mensajes entrantes y salientes procesados por el agente.',
        important: true,
        values: {
          basic: '4,000 / mes',
          professional: '10,000 / mes',
          enterprise: 'Ilimitados',
        },
      },
      {
        id: 'audio-minutes',
        label: 'Minutos de Audio',
        helper: 'Transcripción y procesamiento de notas de voz.',
        important: true,
        values: {
          basic: '400 / mes',
          professional: '1,000 / mes',
          enterprise: 'Ilimitados',
        },
      },
      {
        id: 'ai-models',
        label: 'Modelos de IA',
        helper: 'Potencia y velocidad del cerebro de tu agente.',
        important: true,
        values: {
          basic: 'Modelo Inteligente y Capaz',
          professional: 'Ultrarrápido + Última Generación',
          enterprise: 'Ecosistema de IA a Medida',
        },
      },
      {
        id: 'knowledge-base',
        label: 'Base de Conocimiento',
        helper: 'Archivos y URLs que el agente puede usar para responder (FAQ/KB).',
        values: {
          basic: true,
          professional: true,
          enterprise: true,
        },
      },
    ],
  },
  {
    id: 'automation',
    label: 'Acciones y Automatizaciones',
    features: [
      {
        id: 'booking-google-calendar',
        label: 'Agenda con Google Calendar',
        helper: 'Acción para crear/editar/cancelar eventos en Google Calendar.',
        important: true,
        values: {
          basic: false,
          professional: true,
          enterprise: true,
        },
      },
      {
        id: 'webhook-dispatch',
        label: 'Webhooks (integraciones)',
        helper:
          'Envía el contexto de la conversación a un webhook para integraciones personalizadas.',
        important: true,
        values: {
          basic: false,
          professional: true,
          enterprise: true,
        },
      },
      {
        id: 'survey-nps',
        label: 'Encuestas NPS',
        helper: 'Acción para enviar encuestas y medir satisfacción (NPS).',
        values: {
          basic: false,
          professional: true,
          enterprise: true,
        },
      },
      {
        id: 'payments',
        label: 'Pagos (Stripe / MercadoPago)',
        helper: 'Acciones para generar enlaces de pago desde la conversación.',
        values: {
          basic: false,
          professional: false,
          enterprise: true,
        },
      },
      {
        id: 'crm-actions',
        label: 'Acciones CRM',
        helper: 'Acciones para sincronizar contactos/deals en CRM (ej. HubSpot, Pipedrive).',
        values: {
          basic: false,
          professional: false,
          enterprise: true,
        },
      },
    ],
  },
  {
    id: 'support',
    label: 'Soporte y Seguridad',
    features: [
      {
        id: 'support-level',
        label: 'Nivel de Soporte',
        values: {
          basic: 'Email estándar',
          professional: 'Email prioritario + Chat',
          enterprise: 'Gerente de cuenta dedicado',
        },
      },
      {
        id: 'sla',
        label: 'SLA Garantizado',
        helper: 'Acuerdo de nivel de servicio para uptime y tiempos de respuesta.',
        values: {
          basic: false,
          professional: false,
          enterprise: true,
        },
      },
      {
        id: 'onboarding',
        label: 'Onboarding Asistido',
        helper: 'Ayuda personalizada para configurar tu primer agente.',
        values: {
          basic: false,
          professional: 'Sesión de 30 min',
          enterprise: 'Implementación completa',
        },
      },
    ],
  },
]
